class ContentCarousel extends HTMLElement {
  constructor() {
    super();
    this._onNext = () => this._slider?.next();
    this._onPrev = () => this._slider?.previous();
  }

  connectedCallback() {
    this._initSlider();

    this._resizeObserver = new ResizeObserver(() => {
      if (this._slider) {
        this._slider.destroy();
      }
      this._initSlider();
    });
    this._resizeObserver.observe(this);

    // fade in on intersection
    this.style.opacity = '0';
    this.style.transition = 'opacity 0.8s ease';
    this._intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.style.opacity = '1';
          this._intersectionObserver.disconnect(); // only fire once
        }
      });
    }, { threshold: 0.2 }); // 20% visible before firing
    this._intersectionObserver.observe(this);

    document.addEventListener("contentcarousel:next", this._onNext);
    document.addEventListener("contentcarousel:prev", this._onPrev);
  }

  disconnectedCallback() {
    if (this._slider) {
      this._slider.destroy();
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
    document.removeEventListener("contentcarousel:next", this._onNext);
    document.removeEventListener("contentcarousel:prev", this._onPrev);
  }

  _initSlider() {
    if (this.offsetWidth === 0) {
      requestAnimationFrame(() => this._initSlider());
      return;
    }

    const options = {
      cellAlign: "left",
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      fade: true,
      selectedAttraction: 0.025,
      friction: 0.28, 
    };

    if (matchMedia("(max-width: 767px)").matches) {
      options.groupCells = null;
    }

    this._slider = new Flickity(this, options);
    window.addEventListener('load', () => this._slider.resize(), { once: true });
  }
}

customElements.define("content-carousel", ContentCarousel);